<dl class="m-0 rounded-xl border border-border bg-card p-5 shadow-sm">
  <div class="flex gap-3.5 border-b border-border py-3.5 first:pt-0">
    <dt class="w-32 shrink-0 pt-0.5 text-xs font-bold uppercase tracking-wide text-muted-foreground">Brief name</dt>
    <dd class="m-0 min-w-0 flex-1 text-sm leading-relaxed text-foreground">
      @if (createMonitoringService.basicInfoModel().briefTitle.trim()) {
      {{ createMonitoringService.basicInfoModel().briefTitle.trim() }}
      } @else {
      <p class="m-0 text-muted-foreground">Not named yet</p>
      }
    </dd>
  </div>

  <div class="flex gap-3.5 border-b border-border py-3.5">
    <dt class="w-32 shrink-0 pt-0.5 text-xs font-bold uppercase tracking-wide text-muted-foreground">Type</dt>
    <dd class="m-0 min-w-0 flex-1 text-sm leading-relaxed text-foreground">{{ monitorTypeName() }}</dd>
  </div>

  <div class="flex gap-3.5 border-b border-border py-3.5">
    <dt class="w-32 shrink-0 pt-0.5 text-xs font-bold uppercase tracking-wide text-muted-foreground">Product</dt>
    <dd class="m-0 min-w-0 flex-1 text-sm leading-relaxed text-foreground">
      @if (createMonitoringService.selectedProduct(); as product) {
      <p class="m-0 flex items-center gap-2.5">
        @if (product.productImage) {
        <span class="block size-8 shrink-0 overflow-hidden rounded-md">
          <atom-ldg-img inputClass="object-cover" w="full" radius="md"
            [src]="imageService.getImageSource(product.productImage, 'gallery')"></atom-ldg-img>
        </span>
        }
        {{ product.productName }}
      </p>
      } @else {
      <p class="m-0 text-muted-foreground">No product selected</p>
      }
    </dd>
  </div>

  <div class="flex gap-3.5 border-b border-border py-3.5">
    <dt class="w-32 shrink-0 pt-0.5 text-xs font-bold uppercase tracking-wide text-muted-foreground">Document</dt>
    <dd class="m-0 min-w-0 flex-1 text-sm leading-relaxed text-foreground">
      @if (createMonitoringService.requirementsDocumentUrl()) {
      Document attached
      } @else {
      <p class="m-0 text-muted-foreground">No document uploaded</p>
      }
    </dd>
  </div>

  <div class="flex gap-3.5 border-b border-border py-3.5">
    <dt class="w-32 shrink-0 pt-0.5 text-xs font-bold uppercase tracking-wide text-muted-foreground">Date range</dt>
    <dd class="m-0 min-w-0 flex-1 text-sm leading-relaxed text-foreground">
      <p class="m-0">{{ windowStart() | date:'d MMM y' }} – {{ windowUntil() | date:'d MMM y' }}</p>
      @if (usingDefaultWindow()) {
      <p class="m-0 text-muted-foreground">Default window, 30 days before today until 30 days after</p>
      }
    </dd>
  </div>

  <div class="flex gap-3.5 py-3.5 last:pb-0">
    <dt class="w-32 shrink-0 pt-0.5 text-xs font-bold uppercase tracking-wide text-muted-foreground">Creators</dt>
    <dd class="m-0 min-w-0 flex-1 text-sm leading-relaxed text-foreground">{{ creatorSummary() }}</dd>
  </div>
</dl>
